/**
 * Where the navigation bar's top line is on screen, for screens that lay out against it
 * (the leaderboard's jump pill). A tiny module of its own so screens do not import the block.
 */
let provider: ( () => number | null ) | null = null;

export function setNavBarLineProvider( fn: () => number | null ): void
{
  provider = fn;
}

/** Only the block that set the provider removes it: a new block can be built before the old one is destroyed. */
export function clearNavBarLineProvider( fn: () => number | null ): void
{
  if ( provider === fn )
    provider = null;
}

/** Client (CSS px) y of the bar's top line, or null when there is no laid-out bar. */
export function navBarLineClientY(): number | null
{
  return provider ? provider() : null;
}
